<script setup lang="ts">
  defineEmits([
    'selected',
  ]);

  defineProps({
    addresses: { type: Object, required: true },
    loading: { type: Boolean, default: false },
  });
</script>
<template>
  <SfDataLoader :loading="loading">
    <section class="billing-address-picker">
      <SfTile v-for="address in addresses"
        :default="address.default"
        class="billing-address-picker__option"
        shadow
        small
        interactive
        @click="$emit('selected', address)"
        @keydown.space="$emit('selected', address)"
        tabindex="0"
      >
        <template v-if="address.default" #outer>
          <span class="billing-address-picker__address-default">{{ $t('Dane domyślne') }}</span>
        </template>
        <template #title>
          <h4 class="billing-address-picker__address-heading">{{ address.company || address.name }}</h4>
        </template>
        <template #default>
          <address class="billing-address-picker__address-content">
            <p v-if="address.first_line" class="billing-address-picker__first-line">{{ address.first_line }}</p>
            <p v-if="address.second_line" class="billing-address-picker__second-line">{{ address.second_line }}</p>
            <p v-if="address.third_line" class="billing-address-picker__third-line">{{ address.third_line }}</p>
            <p v-if="address.vat_id" class="billing-address-picker__vat-id">NIP: {{ address.vat_id }}</p>
          </address>
        </template>
      </SfTile>
    </section>
  </SfDataLoader>
</template>
<style lang="scss">
  @use "$assets/mixins/media";

  .billing-address-picker {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
    flex-grow: 1;

    &__option {
      position: relative;
      cursor: pointer;
    }

    &__address-content {
      font-style: normal;
      font-size: 0.875rem;
    }

    @include media.query(lg) {
      grid-template-columns: repeat(2, 1fr);
    }

    @include media.query(sm) {
      display: flex;
      flex-direction: column;
      gap: 1rem;
    }
  }
</style>
